"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var i0 = require("@angular/core");
var i1 = require("./not-found.component");
var styles_PageNotFoundComponent = [];
var RenderType_PageNotFoundComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_PageNotFoundComponent, data: {} });
exports.RenderType_PageNotFoundComponent = RenderType_PageNotFoundComponent;
function View_PageNotFoundComponent_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "h2", [], null, null, null, null, null)), (_l()(), i0.ɵted(-1, null, ["Page not found"]))], null, null); }
exports.View_PageNotFoundComponent_0 = View_PageNotFoundComponent_0;
function View_PageNotFoundComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "ng-component", [], null, null, null, View_PageNotFoundComponent_0, RenderType_PageNotFoundComponent)), i0.ɵdid(1, 49152, null, 0, i1.PageNotFoundComponent, [], null, null)], null, null); }
exports.View_PageNotFoundComponent_Host_0 = View_PageNotFoundComponent_Host_0;
var PageNotFoundComponentNgFactory = i0.ɵccf("ng-component", i1.PageNotFoundComponent, View_PageNotFoundComponent_Host_0, {}, {}, []);
exports.PageNotFoundComponentNgFactory = PageNotFoundComponentNgFactory;
//# sourceMappingURL=not-found.component.ngfactory.js.map